<template>
	<div class="content-wrapper">
		<nav aria-label="breadcrumb">
			<ol class="breadcrumb">
				<li class="breadcrumb-item">
					<a href="#">
						<i class="fa fa-home"></i>
						Dashboard
					</a>
				</li>
				<li class="breadcrumb-item active">Experience Fees Report</li>
			</ol>
		</nav>

		<section class="content">
			<div class="container-fluid">
				<ul class="nav nav-tabs">
					<li class="nav-item">
						<router-link to="/session/experience" class="nav-link">
							<h6>Session Wise Report</h6>
						</router-link>
					</li>
					<li class="nav-item">
						<router-link to="/session/experience/month" class="nav-link active">
							<h6>Month Wise Report</h6>
						</router-link>
					</li>
				</ul>

				<div class="row justify-content-md-center">
					<div class="col-sm-12">
						<div class="card">
							<div class="card-header">
								<h3 class="card-title">Experience Fees Report (Month Wise)</h3>
							</div>

							<div class="card-body">
								<div class="row">
									<div class="col-sm-3" v-can="'change_branch'">
										<div class="form-group">
											<label for="branch_id">Branch</label>
											<select class="form-control form-control-sm" v-model="meta.branch_id">
												<option value="" disabled>Select Branch</option>
												<option v-for="branch in branches" :key="branch.branch_id"
													:value="branch.branch_id">
													{{ branch.branch_name }}
												</option>
											</select>
										</div>
									</div>

									<div class="col-sm-3">
										<div class="form-group">
											<label for="from_month">From Month</label>
											<input type="month" class="form-control form-control-sm"
												v-model="meta.from_month">
										</div>
									</div>

									<div class="col-sm-3">
										<div class="form-group">
											<label for="to_month">To Month</label>
											<input type="month" class="form-control form-control-sm"
												v-model="meta.to_month">
										</div>
									</div>

									<div class="col-sm-3">
										<div class="form-group" style="margin-top: 26px !important;">
											<button class="btn btn-sm btn-primary mr-2" @click="index">
												<i class="fa fa-search mr-1"></i>Search
											</button>
											<button class="btn btn-sm btn-danger" @click="discard">
												<i class="fa fa-times mr-1"></i>Discard
											</button>
										</div>
									</div>
								</div>

								<div class="table-responsive">
									<table class="table table-bordered table-striped table-sm">
										<thead>
											<tr>
												<th class="text-center">#</th>

												<!-- Sort by month asc/desc -->
												<th @click="toggleMonthOrder" style="cursor:pointer;">
													Month
													<span>
														<i v-if="meta.order_by === 'asc'" class="fas fa-sort-up"></i>
														<i v-else class="fas fa-sort-down"></i>
													</span>
												</th>

												<th class="text-center">Total Days</th>
												<th class="text-center">Working Days</th>

												<th class="text-center">Total Time</th>

												<th class="text-center">Total Experience Fees</th>
												<th class="text-center">Average / Working Day</th>
												<th class="text-center">Forecasted Fees</th>
												<th class="text-center">GST @ 18%</th>
												<th class="text-center">Balance Fees</th>
											</tr>
										</thead>

										<tbody>
											<tr v-for="(row, idx) in months" :key="row.month">
												<td class="text-center">{{ idx + 1 }}</td>
												<td>{{ formatMonth(row.month) }}</td>

												<td class="text-center">{{ row.total_days }}</td>
												<td class="text-center">{{ row.total_working_days }}</td>

												<td class="text-center">{{ row.total_time }}</td>

												<td class="text-center">{{ $formatCurrency(row.total_experience_fees) }}
												</td>
												<td class="text-center">{{ $formatCurrency(row.average_experience_fees)
												}}</td>
												<td class="text-center">{{
													$formatCurrency(row.forecasted_experience_fees) }}</td>
												<td class="text-center">{{ $formatCurrency(row.total_gst) }}</td>
												<td class="text-center">{{ $formatCurrency(row.balance_experience_fees)
												}}</td>
											</tr>

											<tr v-if="months.length === 0">
												<td colspan="10" class="text-center text-muted">No data for the selected
													range.</td>
											</tr>
										</tbody>

										<tfoot v-if="months.length">
											<tr>
												<th colspan="4" class="text-right">Grand Total Time</th>
												<th class="text-center">{{ grandTotalTime }}</th>
												<th class="text-center">{{ $formatCurrency(grand.total_experience_fees)
												}}</th>
												<th class="text-center">—</th>
												<th class="text-center">—</th>
												<th class="text-center">{{ $formatCurrency(grand.total_gst) }}</th>
												<th class="text-center">{{
													$formatCurrency(grand.balance_experience_fees) }}</th>
											</tr>
										</tfoot>
									</table>
								</div>

							</div><!-- card-body -->
						</div><!-- card -->
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
import moment from "moment";

export default {
	name: "Report.ExperienceFeesMonthReport",
	data() {
		return {
			status: true,
			meta: {
				branch_id: this.$store.getters.user.branch_id,
				from_month: "",
				to_month: "",
				order_by: "asc",      // month order asc|desc
			},
			branches: [],
			errors: [],
			months: [],            // <-- backend months array
		};
	},

	mounted() {
		this.getBranches();
		this.discard(); // sets FY Apr -> current month, then loads
	},

	computed: {
		grand() {
			const init = { total_experience_fees: 0, total_gst: 0, balance_experience_fees: 0, total_time_minutes: 0 };
			return this.months.reduce((acc, m) => {
				acc.total_experience_fees += Number(m.total_experience_fees || 0);
				acc.total_gst += Number(m.total_gst || 0);
				acc.balance_experience_fees += Number(m.balance_experience_fees || 0);
				acc.total_time_minutes += Number(m.total_time_minutes || 0);
				return acc;
			}, init);
		},
		grandTotalTime() {
			const mins = this.grand.total_time_minutes || 0;
			const h = Math.floor(mins / 60);
			const m = mins % 60;
			return `${h} hr ${m} min`;
		},
	},

	methods: {
		formatMonth(ym) {
			// ym = "YYYY-MM"
			return moment(ym, "YYYY-MM").format("MMM YYYY");
		},

		index() {
			const vm = this;
			vm.$store.dispatch("post", {
				uri: "getSessionLogsWithExperienceFeesMonth", // backend should return { months: [...] }
				data: vm.meta
			})
				.then(res => {
					vm.months = res.data.months || [];
				})
				.catch(err => {
					vm.errors = err?.response?.data?.errors || {};
					vm.$store.dispatch("error", err?.response?.data?.message || "Failed to load data");
				});
		},

		getBranches() {
			const vm = this;
			vm.$store.dispatch("post", { uri: "getBranches" })
				.then(res => vm.branches = res.data.data || [])
				.catch(err => {
					vm.errors = err?.response?.data?.errors || {};
					vm.$store.dispatch("error", err?.response?.data?.message || "Failed to load branches");
				});
		},

		discard() {
			// Default range: Financial Year start (April) -> current month
			const currentMonthIndex = moment().month(); // 0=Jan
			const currentYear = moment().year();

			const fyStart = currentMonthIndex < 3
				? moment([currentYear - 1, 3])  // Apr of last year
				: moment([currentYear, 3]);     // Apr of this year

			this.meta.from_month = fyStart.format("YYYY-MM");
			this.meta.to_month = moment().format("YYYY-MM");
			this.meta.order_by = "asc";
			this.index();
		},

		toggleMonthOrder() {
			this.meta.order_by = this.meta.order_by === "asc" ? "desc" : "asc";
			this.index();
		},
	},
};
</script>
